<template>
  <div id="afterSale">
    <img src="../../assets/img/pagess/afterSale/1.png" alt="">
    <img src="../../assets/img/pagess/afterSale/2.jpg" alt="">
    <img src="../../assets/img/pagess/afterSale/3.jpg" alt="">
    <img src="../../assets/img/pagess/afterSale/4.jpg" alt="">
    <img src="../../assets/img/pagess/afterSale/5.jpg" alt="">
  </div>
</template>


<script>
export default {
  data() {
    return {
      res: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
* {
  font-size: 0;
}
img {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/pagess/afterSale.vue